import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Container,
    Paper,
    Typography,
    Button,
    Box,
    Chip
} from '@mui/material';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const SuccessMsgPage = () => {
    const navigate = useNavigate();
    const [message, setMessage] = useState("Your feedback has been successfully submitted.");

    useEffect(() => {
        // Get message from localStorage
        const storedMsg = localStorage.getItem('successMsg');
        
        if (storedMsg) {
            setMessage(storedMsg);
            // Optional: Clear the message after reading it
            // localStorage.removeItem('successMsg');
        }
    }, []);

    const handleBack = () => {
        navigate(-1); // Go back to previous page
    };

    return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
            <Paper 
                elevation={3} 
                sx={{ 
                    p: 6, 
                    borderRadius: 2, 
                    textAlign: 'center',
                    bgcolor: 'background.paper'
                }}
            >
                {/* Success Icon */}
                <TaskAltIcon sx={{ fontSize: 64, color: 'success.main', mb: 2 }} />

                {/* Main Title */}
                <Typography variant="h4" fontWeight={600} sx={{ mb: 1 }}>
                    Thank You!
                </Typography>

                {/* Success Message */}
                <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                    {message}
                </Typography>

                {/* Status Chip */}
                <Chip
                    icon={<CheckCircleIcon />}
                    label="Form Submitted Successfully"
                    color="success"
                    variant="outlined"
                    sx={{ mb: 3 }}
                />

                {/* Back Button */}
                <Box sx={{ mt: 2 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleBack}
                        size="medium"
                        sx={{ minWidth: 120 }}
                    >
                        Back
                    </Button>
                </Box>
            </Paper>
        </Container>
    );
};

export default SuccessMsgPage;